/**
 * To load the app only after all libraries are loaded
 * @param {_this} _this vue this and in component data exists loading 
 */
export const onReadyStateChange = (_this) => {
  document.onreadystatechange = function () {
    //To load the app only after all libraries are loaded
    if (document.readyState == "complete") {
      _this.loading = false
    }
  }
}